import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Overview from './pages/Overview';
import FoodCategory from './pages/categories/FoodCategory';
import Ratings from './pages/Ratings';
import Orders from './pages/Orders';
import Customers from './pages/Customers';
import Complaints from './pages/Complaints';
import Settings from './pages/settings/Settings';
import Notification from './pages/Notification';
import TransactionHistory from './pages/TransactionHistory';
import DeliveryAgent from './pages/DeliveryAgents';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminRoute from './routes/AdminRoute';

function App() {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route element={<AdminRoute path="overview"/>} >
            <Route path='/overview' element={<Overview/>} />
         </Route>
        <Route element={<AdminRoute path="category"/>}>
            <Route path='/category' element={<FoodCategory/>} />
         </Route>
        <Route element={<AdminRoute path="order"/>}>
            <Route path='/orders' element={<Orders />} />
        </Route>
        <Route element={<AdminRoute path="customers"/>}>
            <Route path='/customers' element={<Customers />} />
        </Route>
        <Route element={<AdminRoute path="delivery-agents"/>}>
            <Route path='/delivery-agents' element={<DeliveryAgent />} />
        </Route>
        <Route element={<AdminRoute path="ratings"/>}>
            <Route  path='/ratings' element={<Ratings />} />
        </Route>
        <Route element={<AdminRoute path="complaints"/>}>
              <Route path='/complaints' element={<Complaints />} />
        </Route>
        <Route element={<AdminRoute path="settings"/>}>
              <Route path='/settings' element={<Settings />} />
        </Route>
        <Route element={<AdminRoute path="notification"/>}>
              <Route path='/notification' element={<Notification />} />
        </Route>
        <Route element={<AdminRoute path="notification"/>}>
              <Route path='/transaction' element={<TransactionHistory />} />
        </Route>
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000} 
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
